type ChevronLeftIconProps = {
  className?: string;
  width?: string | number;
  height?: string | number;
};

export const ChevronLeftIcon = (props: ChevronLeftIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M10 12L6 8L10 4"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
